

<div class="opciones" *ngIf="(flagDatosOption)" >

    <!-- SELECT -->
    <mat-form-field appearance="fill">
        <mat-label>Dispositivo</mat-label>
        <mat-select [(value)]="selectedDisp" [(ngModel)]="selectOpcion" (ngModelChange)="onOptionSelected()">
        <!-- <mat-option></mat-option> -->
        <mat-option [value]="option.value" *ngFor="let option of opcionesDisp">{{ option.viewValue }}</mat-option>
        </mat-select>
    </mat-form-field>


    <!-- RADIOBUTTONS -->
    <mat-radio-group
        aria-labelledby="radio-group-label"
        class="radio-group"
        [(ngModel)]="grafica">
    <mat-radio-button class="radio-button" 
        *ngFor="let grafica of data.graficas; let i =index" 
        [value]="grafica"
        (change)="onOptionradioSelected(grafica)">
            {{grafica.text}}
    </mat-radio-button>
    </mat-radio-group>

    <!-- DATEPICKER-1 -->
    <mat-form-field appearance="fill">

        <mat-label>Rango de fechas</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="rangePicker">
          <input matStartDate formControlName="start" placeholder="Start date" >
          <input matEndDate   formControlName="end"   placeholder="End date"   >
        </mat-date-range-input >
    
        <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker>
    
            <mat-date-range-picker-actions > 
                <button  mat-button class="btnaplicar" matDateRangePickerCancel > Cancelar </button > 
                <button  mat-button  class="btnaplicar"  matDateRangePickerApply (click)="dateSelected()"> Aplicar </button > 
          </mat-date-range-picker-actions > 
        </mat-date-range-picker>
    
        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
    </mat-form-field>


    <button mat-raised-button class="btnaplicar" (click)="cargarGrafica()">Aplicar Cambios</button>
</div>

<!-- GRAFICA -->
<app-grafica-line 
    class="chart" 
    [dataGrafica] = "this.dataGrafica"
    [flagCargaGrafica] = "this.flagCargaGrafica"
    
>
</app-grafica-line>

<!-- <div class="chart"
     *ngIf="(!flagDatos)"
></div> -->

<!-- <app-grafica-line 
    class="chart" 
    *ngIf="(flagDatos)"
    [data] = "this.dataChartArray"
    [tipoGrafica] = "this.graficaSelect"   
    [time] = "this.time"
>
</app-grafica-line> -->



  <!-- <p>Selected range: {{range.value}}</p> -->